<template lang="pug">

include ../../../../pug/mixins/index

+b.select(:class="{ 'select--active': visible }")
  +e.wrapper(v-text="text", @click="visible = !visible" v-if="!visible")
  slot(:value='value', :update='changelang', :visible='visible')
  //- div.select__link(v-for='(item, index) in items' v-if="visible" v-text="item.lang" @click='updateTitle(item.lang)')

</template>

<script>

import Translatable from '@shared/mixins/translatable'

export default {
  props: {
    value: String,
    initial: String,
    lang: String
  },

  data() {
    return {
      visible: false,
      text: this.initial
    }
  },

  mounted() {
    $(document).on('click', e => {
      if ($(this.$el).find(e.target).length == 0) {
        this.visible = false
      }
    })
  },

  methods: {
    changelang(code) {
      this.visible = false;
      if (code == this.lang) {
        return
      }

      if (code == 'uk'){
        window.location.assign(`/${window.location.pathname.substr(3)}`)
      } else {
        window.location.assign(`/${code}${window.location.pathname}`)
      }
    },

    updateTitle(text) {
      this.text = text;
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/js/shared/components/select/select.vue